import {serverTimestamp, Timestamp} from '@angular/fire/firestore';
import {IOperationalEventTimestamp} from '../../../shared-utilities/models-old/datastructures';
import {firebaseTimeStampToDate} from './firestore.utils';

/**
 * Server-assigned time for `api_events.creationDate` and `messages/from_app.timestamp`.
 * Do not use `Date`, `Timestamp.now()`, or the browser clock for these fields (FE-272).
 */
export function createOperationalServerTimestamp(): ReturnType<typeof serverTimestamp> {
  return serverTimestamp();
}

/**
 * Converts a persisted operational timestamp to a `Date` (not valid for pending `serverTimestamp()` writes).
 */
export function readOperationalEventTimestamp(value: IOperationalEventTimestamp): Date | null {
  return firebaseTimeStampToDate(value as Date | Timestamp | { seconds: number; nanoseconds?: number });
}

/**
 * Operational timestamp for client UI (e.g. same-day duplicate guards on live `from_app` snapshots).
 *
 * While a `serverTimestamp()` write is in flight, Firestore exposes `timestamp` as `null` on the local
 * snapshot. Treat that as "now" so in-flight orders still count as created today until the server time arrives.
 */
export function readOperationalEventTimestampForUi(
  value: IOperationalEventTimestamp | null | undefined,
): Date {
  if (value === null || value === undefined) {
    return new Date();
  }
  const resolved: Date | null = readOperationalEventTimestamp(value);
  return resolved ?? new Date();
}
